import { orchestrator } from 'satcheljs';
import { onCloseHeaderPane } from 'owa-app-pane-group-actions';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import closeHeaderPane from './closeHeaderPane';

orchestrator(onCloseHeaderPane, ({ headerPaneName, targetWindow }) => {
    closeHeaderPane(getDrawerPaneId(headerPaneName), targetWindow);
});
